export class SorterReturnsSummaryReportRowDto {
    periodStart: string;
    deviceName: string;
    count: number;

    // display override
    periodDisplay: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/dtos/reports/sorter/sorter-returns-summary-report-row.dto.ts